module.exports = __webpack_public_path__ + "assets/img/logo.1da63423.png";